import axios from 'axios';
import { ILocalStoreKey } from '../types';

export function getUTMParams() {
  const queryParams = localStorage.getItem(ILocalStoreKey.loginQueryParamsData);
  const params = new URLSearchParams(queryParams || undefined);

  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');
  const utmContent = params.get('utm_content');
  const utmTerm = params.get('utm_term');

  return {
    utmSource,
    utmMedium,
    utmCampaign,
    utmContent,
    utmTerm,
  };
}

export async function pixelTrackEvent(event: string = 'CompleteRegistration', eventId: string) {
  const pixelId = 1449138822296552;

  const { utmSource, utmMedium, utmCampaign, utmContent, utmTerm } = getUTMParams();

  await axios.get(`https://www.facebook.com/tr`, {
    params: {
      id: pixelId,
      ev: event,
      eventID: eventId,
      utmSource: utmSource || undefined,
      utmMedium: utmMedium || undefined,
      utmCampaign: utmCampaign || undefined,
      utmContent: utmContent || undefined,
      utmTerm: utmTerm || undefined,
    },
  });
  return { eventId };
}

//  https://development.payblox.com/merchant/login?utm_source=google.com&utm_medium=test-m&utm_campaign=compaign&utm_content=content&utm_term=term
